module.exports = __webpack_public_path__ + "img/barrel_sleeve2.6c4ef732.png";